import { render } from "./SubMenus.vue?vue&type=template&id=340a9ad2&scoped=true"
import script from "./SubMenus.vue?vue&type=script&lang=js"
export * from "./SubMenus.vue?vue&type=script&lang=js"

import "./SubMenus.vue?vue&type=style&index=0&id=340a9ad2&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340a9ad2"]])

export default __exports__